import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "37",
  width: "50",
  viewBox: "0 0 50 37",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M44.333 36.9H5.666C2.5 36.9 0 34.4 0 31.2V6.533C0 3.366 2.5.866 5.667.866h38.667C47.5.866 50 3.366 50 6.533v24.75c0 3.083-2.5 5.583-5.666 5.583z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b4cc4e"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#b4cc4e",
    d: "M29.167 28.817c-1.084 1.083-2.417 1.666-3.917 1.666s-2.917-.583-3.917-1.666l-.083-.084-20.917-24C.083 5.317 0 5.9 0 6.567v24.75c0 3.166 2.5 5.666 5.667 5.666h38.666c3.167 0 5.667-2.5 5.667-5.666V6.567c0-.5-.084-1-.167-1.417L29.167 28.817z"
  }), /*#__PURE__*/_jsx("path", {
    opacity: ".15",
    d: "M48.666 3.233l-21.416 21.5c-1.083 1.084-2.833 1.084-3.917 0l-22-21.916C.833 3.4.5 3.983.25 4.733l20.917 24 .083.084c1.083 1.083 2.417 1.666 3.917 1.666s2.916-.583 3.916-1.666l.084-.084L49.75 5.067c-.167-.75-.5-1.417-1-2 0 .083 0 .166-.084.166z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#d9ed66",
    d: "M27.25 24.733l21.5-21.5.166-.166c-1-1.334-2.666-2.25-4.5-2.25H5.666c-1.75 0-3.25.75-4.333 2L23.25 24.733c1.083 1.084 2.833 1.084 4 0z"
  })]
});